import { error } from '@sveltejs/kit'
import { globByFullPathname } from "$content"

export function load({ params }) {
	const found = globByFullPathname.get(params.slug)
	if (!found) return error(404, "Page not found")

	return {
		content: found.default,
		metadata: found.metadata,
	}
}
